import styleVars from '../src/styles/scss/_variables.scss';

export const ESC_KEY_CODE = 27;
export const CART_BUTTON_SELECTOR = '#cart-button';
export const MOBILE_WIDTH_MEDIA_QUERY = '(max-width: 400px)';

export const MINICART_POPUP_TIP_MARGIN = 5;
export const MINICART_POPUP_TIP_CENTER_OFFSET = 20;
export const MINICART_POPUP_TIP_HEIGHT = Math.round(parseInt(styleVars.minicartTipSide, 10) * Math.sqrt(2));
export const MINICART_WIDTH = parseInt(styleVars.minicartWidth, 10);

export const IS_SUBSCRIBED_COOKIE = 'isSubscribedToReminder';
